<template>
  <div
    class="help-page-root"
    :class="{ 'help-page-root--indiv': isHelpIndiv }"
  >
    <!-- <nnav></nnav> -->

    <div
      class="help_box"
      :style="{
        height: helpBoxHeight,
      }"
    >
      <div class="help_left" style="position: relative;">
        <!-- <div class="block" style="position: absolute;left: 0;top: 80px;">
          <el-slider :step="10" show-stops  v-model="value" vertical height="1200px">
          </el-slider>
        </div> -->
        <div
          style="padding-left: 10px;font-size: 20px;color: #5B85FF;font-weight: 500;cursor: pointer;margin-bottom: 10px;"
          @click="jump2"
        >
          {{ title }}
        </div>
        <a
          v-for="(item, index) in res.data"
          :key="index"
          style="cursor: pointer;display: block;box-sizing: border-box;padding-left: 30px;color: #181E2D;margin-bottom: 15px;font-size: 18px;"
        >
          <div
            :class="{ active_color: active == item.name }"
            @click="jump(item.md, item.name, item)"
            style="font-size: 16px;padding: 3px 0 8px;position: relative;"
          >
            <i
              v-show="!item.deleted && item.childs.length"
              class="el-icon-caret-bottom"
              style="position: absolute;left: -15px;top: 6px;"
            ></i>
            <i
              v-show="item.deleted && item.childs.length"
              class="el-icon-caret-top"
              style="position: absolute;left: -17px;top: 6px;"
            ></i>
            {{ item.name }}
          </div>
          <div
            v-show="!item.deleted"
            :class="{ active_color: active == e.name }"
            style="font-size: 14px;padding: 3px 22px;position: relative;"
            v-for="(e, i) in item.childs"
            :key="i"
            @click="jump(e.md, e.name, e)"
          >
            <span
              style="position: absolute;display: block;width: 10px;height: 25px;border-bottom: 1px dashed #CED5E4;border-left: 1px  dashed #CED5E4;left: 7px;top: -12px;"
            ></span>
            {{ e.name }}
          </div>
        </a>
      </div>

      <div
        class="help_right help-faq-html-root"
        :class="{ 'help_right--type9': isHelpType9 }"
      >
        <div style="height: 30px;"></div>
        <div
          :id="title"
          style="font-size: 24px;font-weight: 500;margin-bottom: 40px;color:#5B85FF"
        >
          {{ title }}
        </div>
        <div v-for="(item, index) in res.data" :key="index">
          <h3
            style="font-size: 18px;font-weight: 500;margin-bottom: 20px;color:#5B85FF;display: flex;margin-top: 20px;"
            :id="'a' + item.id"
          >
            <p
              style="width: 3px;height: 16px;background-color: #5B85FF;margin-top: 5px;margin-right: 10px;"
            ></p>
            {{ item.name }}
          </h3>
          <div v-html="item.text"></div>
          <div v-for="(e, i) in item.childs" :key="i">
            <h2
              :id="'a' + e.id"
              style="font-size: 16px;font-weight: 500;margin: 20px 0;color:#5B85FF"
            >
              {{ e.name }}
            </h2>
            <div v-html="e.text"></div>
          </div>
        </div>
      </div>
    </div>

    <ConsultFloatBar v-if="isHelpIndiv" />
  </div>
</template>
<script>
import nnav from '../../components/nav/index';
import ConsultFloatBar from '@/components/consultFloatBar/index.vue';
import './style.css';
import $ from 'jquery';
export default {
  components: { nnav, ConsultFloatBar },
  computed: {
    /** 个人端（与账户列表等页一致：路由 query from=indiv） */
    isHelpIndiv() {
      return this.$route.query.from === 'indiv';
    },
    /** type=9 时右侧内容区加大行高 */
    isHelpType9() {
      return this.$route.query.type === '9';
    },
    /** 主内容区高度：视口减头部占位；个人端再减 27px（如 IndivNav 条） */
    helpBoxHeight() {
      const base = document.documentElement.clientHeight - 54;
      const indivExtra = this.isHelpIndiv ? 27 : 0;
      return `${base - indivExtra}px`;
    },
  },
  data() {
    return {
      res: [],
      tr: true,
      childs: [],
      type: '',
      active: '',
      title: '',
      value: 0,
    };
  },
  mounted() {
    this.type = this.$route.query.type;
    this.$axios
      .post('/api/helps', { type: this.type })
      .then((res) => {
        console.log(res);
        res.data.data.forEach((item) => {
          item.md = '#a' + item.id;

          if (item.childs) {
            item.childs.forEach((e) => {
              this.childs.push(e.id);
              e.md = '#a' + e.id;
            });
          }
        });

        this.res = res.data;

        this.$nextTick(() => {
          this.fixHelpImages();
          //带参数进网页
          setTimeout(() => {
            this.res.data.forEach((item) => {
              console.log(item.name, 666);
              if (this.$route.query.name == item.name) {
                if (this.$route.query.name == item.name) {
                  this.jump(item.md, item.name, item);
                }
              }

              if (item.childs) {
                item.childs.forEach((e) => {
                  this.childs.push(e.id);
                  e.md = '#a' + e.id;

                  if (this.$route.query.name == e.name) {
                    this.jump(e.md, e.name, e);
                  }
                });
              }
            });
          }, 0);
        });
      })

      .catch((err) => {
        // console.log(err);
      });
  },
  methods: {
    /** 仅处理帮助文档 v-html 内的相对路径图片，避免影响全站其它 p img */
    jump(id, name, e) {
      console.log(id);
      e.deleted = !e.deleted;
      document.querySelector(id).scrollIntoView(true);
      this.active = name;
      //querySelector可以获取dom元素，括号内为css属性选择器；
      // console.log(e);
    },
    jump1(id) {
      document.querySelector(id).scrollIntoView(true);
    },
    jump2() {
      var title = '#' + this.title;
      document.querySelector(title).scrollIntoView(true);
      // console.log(title);
    },
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    fixHelpImages() {
      const root = this.$el && this.$el.querySelector('.help-faq-html-root');
      if (!root) return;
      const base = 'https://yunsrvwebapi.jeesit.com';
      root.querySelectorAll('img').forEach((img) => {
        const src = img.getAttribute('src');
        if (!src || /^https?:\/\//i.test(src) || src.indexOf(base) === 0) {
          return;
        }
        img.src = base + src;
      });
    },
  },
  watch: {
    type() {
      if (this.type == '4') {
        this.title = '交易端手册';
      }
      if (this.type == '5') {
        this.title = '多账户交易端手册';
      }
    },
  },
};
</script>
<style>
.el-menu {
  border-right: 0 !important;
}
.el-submenu .el-menu-item {
  height: 28px;
  line-height: 28px;
}
.el-menu-item,
.el-submenu__title {
  height: 28px;
  line-height: 28px;
}
.el-menu-item-group__title {
  padding: 0;
}
</style>

<style scoped>
/* 个人端：整视口宽度铺灰底，内容区仍 1200px 居中 */
.help-page-root--indiv {
  background-color: #f8f9fb;
}
.help-page-root--indiv .help_box {
  max-width: 1200px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
  background: transparent;
  padding: 20px 0;
}
.help_right--type9 {
  line-height: 1.8;
}
</style>



// WEBPACK FOOTER //
// src/view/help/index.vue